import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Icon } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIInfo extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        return (
            <div className={css.ModalChangePhoneNum}>
                <div className={css.header}>
                    <div className={css.title}>修改手机号</div>
                </div>
                <div className={css.content}>
                    <div className={css.successTip}>
                        <Icon type="check-circle" style={{fontSize: '52px', color: '#000000'}}/>
                        <div className={css.tipDes}>更换成功</div>
                    </div>
                    <div className={css.footerBt}>
                        <Button onClick={ModulesAction.closeChangePhoneM}className={css.nextBt}>确认</Button>
                    </div>
                                
                </div>
            </div>
        );
    }
    /** 下一步 */
    private nextStep = () => {
        this.props.form.validateFields((err, val) => {
            if (!err) {
                console.log(val);
                ModulesAction.verificationPassword(val);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/UI.ChangePhoneSuccess.tsx